// extracted by mini-css-extract-plugin
export var explainable = "_gh-a";
export var printerCard = "_gh-1";
export var printerCardConfigured = "_gh-2";
export var printerCardError = "_gh-3";
export var printerCardsContainer = "_gh-0";
export var printerIcon = "_gh-8";
export var printerIconConfigured = "_gh-5";
export var printerIconContainer = "_gh-4";
export var printerIconError = "_gh-6";
export var printerIconUnconfigured = "_gh-7";
export var workstationsTableCard = "_gh-9";